module.exports = __webpack_public_path__ + "img/placket width.ee424847.png";